/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendEnumDto } from '../../models/backend-enum-dto';

export interface ProjectsExchangeProjectFilterEnumsRetrieve$Params {}

export function projectsExchangeProjectFilterEnumsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsExchangeProjectFilterEnumsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendEnumDto>> {
  const rb = new RequestBuilder(rootUrl, projectsExchangeProjectFilterEnumsRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendEnumDto>;
    }),
  );
}

projectsExchangeProjectFilterEnumsRetrieve.PATH = '/api/projects/exchange/project-filter-enums/';
